import * as THREE from "three";
export class SceneLights {
    constructor(scene) {
        this.scene = scene;
        this.createSceneLight();
    }
    /** Default lightning **/
    createSceneLight() {
        const hemiLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 1);
        hemiLight.color.setHSL(0.6, 1, 0.6);
        hemiLight.groundColor.setHSL(0.095, 1, 0.9);
        hemiLight.position.set(0, 50, 0);
        this.scene.threeScene.add(hemiLight);
        const light = new THREE.AmbientLight(0x404040, 0.5);
        this.scene.threeScene.add(light);
        const dirLight = new THREE.DirectionalLight(0xfdfbd3, 1.8);
        dirLight.color.setHSL(0.1, 1, 0.95);
        dirLight.position.set(1, 30, 0.5);
        dirLight.position.multiplyScalar(30);
        this.scene.threeScene.add(dirLight);
        dirLight.castShadow = true;
        dirLight.shadow.camera.visible = true;
        dirLight.shadow.mapSize.width = dirLight.shadow.mapSize.height = 1024 * 2;
        const d = 2000;
        dirLight.shadow.camera.left = -d;
        dirLight.shadow.camera.right = d;
        dirLight.shadow.camera.top = d;
        dirLight.shadow.camera.bottom = -d;
        dirLight.shadow.camera.far = 3500;
        dirLight.shadow.bias = -0.0001;
        const light2 = new THREE.PointLight(0x6E384E);
        const light3 = new THREE.PointLight(0x155979);
        light2.position.set(0, 500, 0);
        light3.position.set(0, 500, -350);
        this.scene.threeScene.add(light2, light3);
        /*  if (this.scene.formData.extras.threeAxisLed === false && this.scene.formData.extras.panelLed === false && this.scene.formData.extras.perimeterLed === false && this.scene.formData.extras.spotLed === false && this.scene.formData.extras.linearLed === false) {
              const light1 = new THREE.PointLight(0x6E384E)
              const light4 = new THREE.PointLight(0x155979)
              light1.position.set(0, 500, 550)
              light4.position.set(-500, 250, 0)
              this.scene.threeScene.add(light1, light2, light3, light4);
          }*/
    }
    /** Spotlight on panel / spot extra, point light on the others. 1-4 lights / module, depends on the size **/
    createModuleLights(pos) {
        if (this.scene.formData.extras.threeAxisLed === true || this.scene.formData.extras.panelLed === true || this.scene.formData.extras.perimeterLed === true || this.scene.formData.extras.spotLed === true || this.scene.formData.extras.linearLed === true) {
            const widthLights = this.scene.formData.measuredModel.width > 500 ? 2 : 1;
            const projLights = this.scene.formData.measuredModel.projection > 500 ? 1 : 0;
            let light;
            const finalPos = pos;
            for (let i = 0; i < widthLights; i++) {
                if (this.scene.formData.extras.spotLed === true || this.scene.formData.extras.panelLed === true) {
                    light = new THREE.SpotLight(0xf7f6b5, 3, 500, 1.2);
                    finalPos.y = 255;
                }
                else {
                    light = new THREE.PointLight(0xf7f6b5, 2, 500);
                    finalPos.y = 130;
                }
                finalPos.x -= projLights > 0 ? this.scene.formData.measuredModel.projection / 3.5 : 0;
                let spot;
                light.name = i.toString();
                if (widthLights === 1) {
                    light.position.copy(finalPos);
                    if (this.scene.formData.extras.spotLed === true || this.scene.formData.extras.panelLed === true) {
                        spot = light;
                        spot.target.position.set(finalPos.x, finalPos.y - 130, finalPos.z);
                        spot.target.updateMatrixWorld();
                        this.scene.threeScene.add(spot);
                    }
                    else {
                        this.scene.threeScene.add(light);
                    }
                }
                else {
                    if (i === 0) {
                        finalPos.z -= this.scene.formData.measuredModel.width / 3.5;
                        light.position.copy(finalPos);
                        if (this.scene.formData.extras.spotLed === true || this.scene.formData.extras.panelLed === true) {
                            spot = light;
                            spot.target.position.set(finalPos.x, finalPos.y - 130, finalPos.z);
                            spot.target.updateMatrixWorld();
                            this.scene.threeScene.add(spot);
                        }
                        else {
                            this.scene.threeScene.add(light);
                        }
                    }
                    else {
                        finalPos.z += this.scene.formData.measuredModel.width / 3.5 * 2;
                        light.position.copy(finalPos);
                        if (this.scene.formData.extras.spotLed === true || this.scene.formData.extras.panelLed === true) {
                            spot = light;
                            spot.target.position.set(finalPos.x, finalPos.y - 130, finalPos.z);
                            spot.target.updateMatrixWorld();
                            this.scene.threeScene.add(spot);
                        }
                        else {
                            this.scene.threeScene.add(light);
                        }
                    }
                }
                for (let x = 0; x < projLights; x++) {
                    finalPos.x += this.scene.formData.measuredModel.projection / 3.5 * 2;
                    if (this.scene.formData.extras.spotLed === true || this.scene.formData.extras.panelLed === true) {
                        let light = new THREE.SpotLight(0xf7f6b5, 3, 500, 1.2);
                        light.position.copy(finalPos);
                        light.target.position.set(finalPos.x, finalPos.y - 130, finalPos.z);
                        light.target.updateMatrixWorld();
                        this.scene.threeScene.add(light);
                    }
                    else {
                        light = new THREE.PointLight(0xf7f6b5, 2, 500);
                        light.position.copy(finalPos);
                        this.scene.threeScene.add(light);
                    }
                }
            }
        }
    }
}
